export const apiKey = process.env.REACT_APP_API_KEY;
export const redirectUri = process.env.REACT_APP_REDIRECT_URI;